import React from 'react'
import AsyncSelect from 'react-select/async'

import loadCompanies, { Company } from '../lib/loadCompanies'

const loadOptions = (search?: string) =>
    loadCompanies({ noOfItems: 30, name: search }).then((companies) =>
        companies.map((company: Company) => ({ value: company.id, label: company.name }))
    )

const CompanySelect: React.FC<Props> = ({ onChange }) => {
    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            defaultValue={null}
            loadOptions={loadOptions}
            onChange={(company) => onChange(company?.value)}
        />
    )
}

export default CompanySelect

export type Props = {
    onChange: (companyId: string) => void
}
